import { rolePermissions, type TPermissions, type TPermissionsMap } from './permissions'

// Function to get permissions based on user roles and community
export function getCommunityPermissions(permissionMap: TPermissionsMap): TPermissions {
  const permissions: TPermissions = {
    canManageRoles: false,
    canSendAnnouncements: false,
    canManageContent: false,
    canView: true,
  }

  // Check community roles
  if (permissionMap.isCreator) {
    return rolePermissions['creator']
  }
  if (permissionMap.isAdmin) {
    return rolePermissions['admin']
  }
  if (permissionMap.isAnimator) {
    return rolePermissions['animator']
  }

  // Check if user is a Hozana admin
  if (permissionMap?.user.admin) {
    return rolePermissions['hozanaAdmin']
  }

  return permissions
}
